import React, { memo } from 'react';
import { Wrapper, Value, Label } from './Style';

export const Stat = memo(({ text, value, color, bgColor, onClick }) => {
  const hasClickEvent = typeof onClick === 'function';
  return (
    <Wrapper showPointer={hasClickEvent}>
      <Value color={color} bgColor={bgColor} onClick={hasClickEvent ? onClick : () => null}>
        {value}
      </Value>
      <Label>{text}</Label>
    </Wrapper>
  );
});
